export const makeUnique = <T>(array: T[]) => {
  return [...new Set(array)] as T[];
};
